import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { isAdminUser } from "@/lib/identity";

export type IdentityState = {
  loading: boolean;
  userId: string | null;
  email: string | null;
  isAnonymous: boolean;
  isGuest: boolean;       // anonymous or no session
  isAuthenticated: boolean; // permanent account
  isAdmin: boolean;
};

const initial: IdentityState = {
  loading: true,
  userId: null,
  email: null,
  isAnonymous: false,
  isGuest: true,
  isAuthenticated: false,
  isAdmin: false,
};

export function useIdentity(): IdentityState {
  const [state, setState] = useState<IdentityState>(initial);

  useEffect(() => {
    let cancelled = false;

    const apply = async (session: any) => {
      const user = session?.user ?? null;
      const anon = !!user?.is_anonymous;
      const email = user?.email ?? null;
      const admin = await isAdminUser(email);
      if (cancelled) return;
      setState({
        loading: false,
        userId: user?.id ?? null,
        email,
        isAnonymous: anon,
        isGuest: !user || anon,
        isAuthenticated: !!user && !anon,
        isAdmin: admin,
      });
    };

    supabase.auth.getSession().then(({ data }) => apply(data.session));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, session) => apply(session));
    return () => {
      cancelled = true;
      sub.subscription.unsubscribe();
    };
  }, []);

  return state;
}
